import {
	AfterViewInit,
	Component,
	inject,
	OnDestroy,
	ViewChild,
	OnInit,
} from '@angular/core';
import { Validators } from '@angular/forms';
import { GroupButton } from '@componentes/public-button-group/public-button-group.component';
import { PublicTableComponent } from '@componentes/public-table/public-table.component';
import { DadosRelatorioVariaveis } from '@home/submodulos/dados-meteorologicos/interfaces/response';
import {
	FormularioRelatorio,
	INPUTS_RELATORIOS_PCDS,
	InstanciaRelatorio,
} from '@home/submodulos/dados-meteorologicos/interfaces/tipos-relatorios';
import { RelatoriosService } from '@home/submodulos/dados-meteorologicos/services/relatorios.service';
import { TipoEstacao } from '@modulos/meteorologia/submodulos/estacao/enums/tipo-estacao';
import {
	formatarDataPadraoMesAno,
	isNotNuloOuUndefined,
	numberToBrNumber,
} from '@utils';
import { DateTimeUtils } from '@utils/datetime-util';
import { ADTColumns } from 'angular-datatables/src/models/settings';
import { format, formatISO } from 'date-fns';
import { ToastrService } from 'ngx-toastr';
import {
	exportarPDF,
	exportarCSV,
	exportarTXT,
	exportarXLSX,
} from '../../../utils/exportacao-tabelas';
import { Historico } from '../../../interfaces';
import { corrigeDuplicacaoNome } from '@home/submodulos/dados-meteorologicos/utils';
import { filter, Subscription } from 'rxjs';
import moment from 'moment';
import {
	PERIODO_MAXIMO_EM_ANOS_GRAFICO_PCD,
	PERIODO_MAXIMO_EM_DIAS_GRAFICO_PCD,
	PERIODO_MAXIMO_EM_MESES_GRAFICO_PCD,
} from '../grafico-variaveis-meteorologicas/grafico-variaveis-meteorologicas.component';
import { Select } from '@layout/interfaces/select';

@Component({
	selector: 'seira-variaveis-meteorologicas-tabela',
	templateUrl: './variaveis-meteorologicas-tabela.component.html',
	styleUrls: ['./variaveis-meteorologicas-tabela.component.scss'],
})
export class VariaveisMeteorologicasTabelaComponent
	implements OnDestroy, InstanciaRelatorio, OnInit, AfterViewInit
{
	carregando = false;
	tituloTabela = '';
	inputs = inject(INPUTS_RELATORIOS_PCDS);
	dadosTabelaVariaveis: DadosRelatorioVariaveis[] = [];
	municipioPosto = '';
	opcoesMunPostos: Select<string>[];
	private inscricoes = new Subscription();
	mensagemDataMinima?: string;

	descricaoRelatorio =
		'Define-se como variáveis meteorológicas os parâmetros atmosféricos, como temperatura, umidade, e velocidade do vento, que influenciam as condições climáticas de um local ou região.';

	@ViewChild('tabelaVariaveisMeteorologicas', { static: false })
	tabela?: PublicTableComponent;
	periodoAgrupamento = this.inputs.form.get(FormularioRelatorio.PERIODO_BUSCA)
		?.value;
	colunas: ADTColumns[] = [
		{
			data: 'dataColeta',
			className: 'text-center',
			title: 'Data',
		},
		{
			data: 'precipitacao',
			className: 'text-center',
			title: 'Precipitação (mm)',
		},
		{
			data: 'temperatura',
			className: 'text-center',
			title: 'Temperatura (°C)',
		},
		{
			data: 'temperaturaMaxima',
			className: 'text-center',
			title: 'Temperatura máxima(°C)',
		},
		{
			data: 'temperaturaMinima',
			className: 'text-center',
			title: 'Temperatura mínima (°C)',
		},
		{
			data: 'umidade',
			className: 'text-center',
			title: 'Umidade do ar (%)',
		},
		{
			data: 'umidadeMaxima',
			className: 'text-center',
			title: 'Umidade máxima do ar (%)',
		},
		{
			data: 'umidadeMinima',
			className: 'text-center',
			title: 'Umidade mínima do ar (%)',
		},
		{
			data: 'pressao',
			className: 'text-center',
			title: 'Pressão (hPa)',
		},
		{
			data: 'ventoDirecao',
			className: 'text-center',
			title: 'Direção do vento 1m (°)',
		},
		{
			data: 'ventoVelocidade',
			className: 'text-center',
			title: 'Velocidade do vento 1m (m/s)',
		},
		{
			data: 'radiacao',
			className: 'text-center',
			title: 'Radiação solar (W/m²)',
		},
		{
			data: 'vento2m',
			className: 'text-center',
			title: 'Velocidade do vento 2m (m/s)',
		},
		{
			data: 'ventoDirecao2',
			className: 'text-center',
			title: 'Direção do vento 2m (°)',
		},
		{
			data: 'evapotranspiracaoPotencial',
			className: 'text-center',
			title: 'Evapotranspiração (mm)',
		},
		{
			data: 'conteudoAguaSolo60cm',
			className: 'text-center',
			title: 'Conteúdo água solo 60 cm (%)',
		},
		{
			data: 'conteudoAguaSolo50cm',
			className: 'text-center',
			title: 'Conteúdo água solo 50 cm (%)',
		},
		{
			data: 'conteudoAguaSolo40cm',
			className: 'text-center',
			title: 'Conteúdo água solo 40 cm (%)',
		},
		{
			data: 'conteudoAguaSolo30cm',
			className: 'text-center',
			title: 'Conteúdo água solo 30 cm (%)',
		},
		{
			data: 'conteudoAguaSolo20cm',
			className: 'text-center',
			title: 'Conteúdo água solo 20 cm (%)',
		},
		{
			data: 'conteudoAguaSolo10cm',
			className: 'text-center',
			title: 'Conteúdo água solo 10 cm (%)',
		},
		{
			data: 'temperaturaDoSolo10cm',
			className: 'text-center',
			title: 'Temperatura solo 10 cm (°C)',
		},
		{
			data: 'temperaturaDoSolo20cm',
			className: 'text-center',
			title: 'Temperatura solo 20 cm (°C)',
		},
		{
			data: 'temperaturaDoSolo30cm',
			className: 'text-center',
			title: 'Temperatura solo 30 cm (°C)',
		},
		{
			data: 'temperaturaDoSolo40cm',
			className: 'text-center',
			title: 'Temperatura solo 40 cm (°C)',
		},
		{
			data: 'temperaturaDoSolo50cm',
			className: 'text-center',
			title: 'Temperatura solo 50 cm (°C)',
		},
		{
			data: 'temperaturaDoSolo60cm',
			className: 'text-center',
			title: 'Temperatura solo 60 cm (°C)',
		},
		{
			data: 'ventoDirecao1DesvioPadrao',
			className: 'text-center',
			title: 'Vento direção 1 desvio Padrão (°)',
		},
		{
			data: 'ventoDirecao2DesvioPadrao',
			className: 'text-center',
			title: 'Vento direção 2 desvio Padrão (°)',
		},
		{
			data: 'ventoVelocidade1Maxima',
			className: 'text-center',
			title: 'Vento velocidade 1 máxima (m/s)',
		},
		{
			data: 'ventoVelocidade2Maxima',
			className: 'text-center',
			title: 'Vento velocidade 2 máxima (m/s)',
		},
	];

	colunasTabela: ADTColumns[] = this.colunas;
	dadosTabela: any[] = [];
	private readonly colunaMunicipioPosto: ADTColumns = {
		data: 'municipioPosto',
		className: 'text-left',
		title: 'Municipio/Posto',
	};

	private getColunasTabela(): ADTColumns[] {
		return this.isEstadoCompletoSelecionado
			? [this.colunaMunicipioPosto, ...this.colunas]
			: this.colunas;
	}

	private getDadosTabela(relatorios: DadosRelatorioVariaveis[]): any[] {
		return relatorios.flatMap(relatorio => {
			const municipioPosto = this.obterMunicipioPosto(relatorio);

			return (relatorio.historico ?? []).map(dado => ({
				...dado,
				municipioPosto,
			}));
		});
	}

	private get isEstadoCompletoSelecionado(): boolean {
		return this.getFormItemValue(FormularioRelatorio.ESTACAO) === '0';
	}

	botoesDeExportacao: GroupButton[] = [
		{
			label: '.pdf',
			size: 'small',
			icon: 'ph-file-pdf',
			onClick: () => {
				const dadosOriginais = this.tabela?.data ? this.tabela.data : [];

				const dadosCorrigidos = dadosOriginais.map((d: any) => ({
					...d,
					dataColeta: d.dataColeta,
				}));

				if (this.tabela) {
					(this.tabela as any).getExportData = () => dadosCorrigidos;
				}
				exportarPDF({
					resultados: this.colunasTabela,
					tabela: this.tabela,
					periodoAgrupamento: '',
					tituloTabela: this.tituloTabela,
					tituloMunicipio: this.tituloMunicipioExportacao,
				});
			},
		},
		{
			label: '.csv',
			size: 'small',
			icon: 'ph-file-csv',
			onClick: () => {
				const dadosOriginais = this.tabela?.data ? this.tabela.data : [];

				const dadosCorrigidos = dadosOriginais.map((d: any) => ({
					...d,
					dataColeta: d.dataColeta,
				}));

				if (this.tabela) {
					(this.tabela as any).getExportData = () => dadosCorrigidos;
				}
				exportarCSV({
					tabela: this.tabela!,
					periodoAgrupamento: this.getFormItemValue(
						FormularioRelatorio.PERIODO_BUSCA
					),
					tituloTabela: this.tituloTabela,
					substituicaoPrimeiraColuna: this.substituicaoPrimeiraColuna,
				});
			},
		},
		{
			label: '.txt',
			size: 'small',
			icon: 'ph-file-text',
			onClick: () => {
				const dadosOriginais = this.tabela?.data ? this.tabela.data : [];

				const dadosCorrigidos = dadosOriginais.map((d: any) => ({
					...d,
					dataColeta: d.dataColeta,
				}));

				if (this.tabela) {
					(this.tabela as any).getExportData = () => dadosCorrigidos;
				}
				exportarTXT({
					tabela: this.tabela!,
					periodoAgrupamento: this.getFormItemValue(
						FormularioRelatorio.PERIODO_BUSCA
					),
					titulo: this.tituloTabela,
					tituloMunicipio: this.tituloMunicipioExportacao,
				});
			},
		},
		{
			label: '.xlsx',
			size: 'small',
			icon: 'ph-file-xls',
			onClick: () => {
				const dadosOriginais = this.tabela?.data ? this.tabela.data : [];

				const dadosCorrigidos = dadosOriginais.map((d: any) => ({
					...d,
					dataColeta: d.dataColeta,
				}));

				if (this.tabela) {
					(this.tabela as any).getExportData = () => dadosCorrigidos;
				}
				exportarXLSX({
					tabela: this.tabela,
					periodoAgrupamento: '',
					tituloTabela: this.tituloTabela,
					tituloMunicipio: this.tituloMunicipioExportacao,
					colunasAEsquerda: [0],
				});
			},
		},
	];

	private get substituicaoPrimeiraColuna() {
		if (this.isEstadoCompletoSelecionado) {
			return undefined;
		}

		return {
			titulo: 'Municipio/Posto',
			valor: this.municipioPosto,
		};
	}

	private get tituloMunicipioExportacao(): string | undefined {
		return this.isEstadoCompletoSelecionado ? undefined : this.municipioPosto;
	}

	constructor(
		private toastr: ToastrService,
		private relatoriosService: RelatoriosService
	) {
		const todosMunicipiosPostos = this.inputs.municipioPostos;
		this.opcoesMunPostos = [
			{ value: '0', name: 'Estado completo' },
			...todosMunicipiosPostos,
		];
		this.ouvirMudancasMensagemDataMin();
		this.ouvirMudancasPeriodoBusca();
		this.ouvirMudancasMunPosto();
		this.setValidators();
	}

	ngAfterViewInit(): void {
		this.inputs.form
			.get(FormularioRelatorio.ESTACAO)
			?.patchValue(this.opcoesMunPostos[0].value);
		this.preencherDatas();
		this.gerarRelatorio();
	}

	ngOnInit(): void {
		this.mensagemDataMinima = this.inputs.mensagemDataMinima;
	}

	private preencherDatas(): void {
		const hoje = new Date();
		this.dataInicio = moment(hoje)
			.subtract(PERIODO_MAXIMO_EM_DIAS_GRAFICO_PCD, 'days')
			.toDate();
		this.dataFim = hoje;
	}

	private ouvirMudancasMunPosto(): void {
		this.inputs.form
			.get(FormularioRelatorio.ESTACAO)
			?.valueChanges.subscribe(munPosto => {
				if (munPosto === '0') {
					this.mensagemDataMinima = undefined;
					return;
				}
				const dto = this.inputs.datasPrimeirasColetasPCDs.find(d => {
					return d.id.toString() === munPosto;
				})!;
				if (!dto) {
					return;
				}
				this.dataInicio = this.getInicioDataByPeriodoBusca(dto.dataColeta);
				this.dataFim = this.getDataComAcrescimoByPeriodoBusca(dto.dataColeta);
			});
	}

	private ouvirMudancasMensagemDataMin(): void {
		this.inscricoes.add(
			this.inputs.triggerTrocaMensagemDataMin$
				.pipe(filter(e => isNotNuloOuUndefined(e)))
				.subscribe(mensagem => {
					this.mensagemDataMinima = mensagem;
				})
		);
	}

	private ouvirMudancasPeriodoBusca() {
		this.inscricoes.add(
			this.inputs.form
				.get(FormularioRelatorio.PERIODO_BUSCA)
				?.valueChanges.subscribe(() => {
					if (this.municipioPostoSelecionado !== '0') {
						this.atualizarDatasByDataMinima();
					}
					this.gerarRelatorio();
				})
		);
	}

	private get municipioPostoSelecionado() {
		return this.inputs.form.get(FormularioRelatorio.ESTACAO)?.value;
	}

	private atualizarDatasByDataMinima() {
		this.dataInicio = this.getInicioDataByPeriodoBusca(this.dataMinimaAtual);
		this.dataFim = this.getDataComAcrescimoByPeriodoBusca(this.dataInicio);
	}

	private get dataInicio(): Date {
		return this.inputs.form.get('dataInicio')?.value;
	}

	private get dataFim(): Date {
		return this.inputs.form.get('dataFim')?.value;
	}

	private get dataMinimaAtual(): Date {
		return this.inputs.datasPrimeirasColetasPCDs.find(d => {
			return d.id.toString() === this.municipioPostoSelecionado;
		})!.dataColeta;
	}

	private set dataInicio(novaData: Date) {
		this.inputs.form.get('dataInicio')?.setValue(novaData);
	}

	private set dataFim(novaData: Date) {
		this.inputs.form.get('dataFim')?.setValue(novaData);
	}

	private getInicioDataByPeriodoBusca(data: Date): Date {
		const dataMoment = moment(data);
		const mapeamento: Record<string, moment.unitOfTime.StartOf> = {
			DIARIO: 'day',
			MENSAL: 'month',
			ANUAL: 'year',
		};
		const startOf = mapeamento[this.periodoBusca.toUpperCase()];
		return dataMoment.startOf(startOf).toDate();
	}

	private getDataComAcrescimoByPeriodoBusca(data: Date): Date {
		const mapeamento: Record<string, [number, moment.DurationInputArg2]> = {
			diario: [PERIODO_MAXIMO_EM_DIAS_GRAFICO_PCD, 'day'],
			mensal: [PERIODO_MAXIMO_EM_MESES_GRAFICO_PCD, 'month'],
			anual: [PERIODO_MAXIMO_EM_ANOS_GRAFICO_PCD, 'year'],
		};
		const [amount, unit] = mapeamento[this.periodoBusca];
		return moment(data)
			.add(amount - 1, unit)
			.toDate();
	}

	private get periodoBusca(): string {
		return this.inputs.form.get(FormularioRelatorio.PERIODO_BUSCA)?.value;
	}

	private set periodoBusca(valor: string) {
		this.inputs.form
			.get(FormularioRelatorio.PERIODO_BUSCA)
			?.setValue(valor, { emitEvent: false });
	}

	ngOnDestroy() {
		this.inputs.form.get(FormularioRelatorio.DATA_INICIO)?.clearValidators();
		this.inputs.form.get(FormularioRelatorio.DATA_FIM)?.clearValidators();
		this.inputs.form.get(FormularioRelatorio.PERIODO_BUSCA)?.clearValidators();
		this.inputs.form.get(FormularioRelatorio.ESTACAO)?.clearValidators();
		this.inscricoes.unsubscribe();
	}

	setValidators() {
		this.inputs.form
			.get(FormularioRelatorio.DATA_INICIO)
			?.setValidators(Validators.required);
		this.inputs.form
			.get(FormularioRelatorio.DATA_FIM)
			?.setValidators(Validators.required);
		this.inputs.form
			.get(FormularioRelatorio.PERIODO_BUSCA)
			?.setValidators(Validators.required);
		this.inputs.form
			.get(FormularioRelatorio.ESTACAO)
			?.setValidators(Validators.required);
	}

	getFormItemValue(field: string) {
		return this.inputs.form.get(field)?.value;
	}

	gerarRelatorio(): void {
		const idPosto = this.getFormItemValue(FormularioRelatorio.ESTACAO);
		const periodoBusca = this.getFormItemValue(
			FormularioRelatorio.PERIODO_BUSCA
		);

		this.tituloTabela = `Variáveis meteorológicas - ${DateTimeUtils.formatarDataPeriodo(
			this.dataInicio,
			this.dataFim,
			periodoBusca
		)}`;

		this.carregando = true;
		this.inputs.setLoading(true);

		if (idPosto === '0') {
			this.relatoriosService
				.buscarRelatorioVariaveisTodosMunicipios({
					tipo: TipoEstacao.PCD,
					diaInicio: formatISO(this.dataInicio),
					diaFim: formatISO(this.dataFim),
					periodo: periodoBusca,
				})
				.subscribe({
					next: resp => {
						this.dadosTabelaVariaveis = this.padronizarResultado(resp);
						this.relatoriosService.atualizaVisibilidadeBotoesExportacao(resp);
					},
					error: err => {
						this.toastr.error('Ocorreu um erro ao gerar o relatório', err);
						this.carregando = false;
						this.inputs.setLoading(false);
					},
					complete: () => {
						this.carregando = false;
						this.inputs.setLoading(false);
					},
				});
		} else {
			this.relatoriosService
				.buscarRelatorioVariaveis(
					idPosto,
					formatISO(this.dataInicio),
					formatISO(this.dataFim),
					periodoBusca
				)
				.subscribe({
					next: variaveis => {
						this.dadosTabelaVariaveis = this.padronizarResultado([variaveis]);
						this.relatoriosService.atualizaVisibilidadeBotoesExportacao(
							variaveis.historico
						);
					},
					error: err => {
						this.toastr.error('Ocorreu um erro ao gerar o relatório', err);
						this.carregando = false;
						this.inputs.setLoading(false);
					},
					complete: () => {
						this.carregando = false;
						this.inputs.setLoading(false);
					},
				});
		}
	}

	padronizarResultado(
		relatorios: DadosRelatorioVariaveis[]
	): DadosRelatorioVariaveis[] {
		if (!relatorios || relatorios.length === 0) {
			this.dadosTabela = [];
			this.colunasTabela = this.getColunasTabela();
			return [];
		}

		this.municipioPosto = this.isEstadoCompletoSelecionado
			? 'Estado completo'
			: this.obterMunicipioPosto(relatorios[0]);

		const relatoriosFormatados = relatorios.map(relatorio => ({
			...relatorio,
			historico: (relatorio.historico ?? []).map(dado => {
				let dataColeta = '-';
				const periodo = this.getFormItemValue(
					FormularioRelatorio.PERIODO_BUSCA
				);
				if (periodo === 'diario') {
					const [ano, mes, dia] = (dado.diaReferencia as string)
						.split('-')
						.map(e => Number(e));
					const date = new Date(ano, mes - 1, dia);
					dataColeta = format(date, 'dd/MM/yyyy');
				} else if (periodo === 'mensal') {
					dataColeta = formatarDataPadraoMesAno(dado.mes, dado.ano);
				} else if (periodo === 'anual') {
					dataColeta = dado.ano.toString();
				}

				return {
					...dado,
					dataColeta,
					precipitacao: isNotNuloOuUndefined(dado.precipitacao)
						? numberToBrNumber(dado.precipitacao, 1)
						: '-',
					...this.formatarCampos(dado, [
						'temperatura',
						'temperaturaMaxima',
						'temperaturaMinima',
						'umidade',
						'umidadeMaxima',
						'umidadeMinima',
						'pressao',
						'ventoDirecao',
						'ventoVelocidade',
						'radiacao',
						'vento2m',
						'ventoDirecao2',
						'temperaturaDoSolo',
						'umidadeSolo',
						'evapotranspiracaoPotencial',
						// 'correnteRecarga',
						// 'sensorPortaAberta',
						// 'umidadeInterna',
						// 'temperaturaInterna',
						// 'tensaoBateria',
						'conteudoAguaSolo60cm',
						'conteudoAguaSolo50cm',
						'conteudoAguaSolo40cm',
						'conteudoAguaSolo30cm',
						'conteudoAguaSolo20cm',
						'conteudoAguaSolo10cm',
						'temperaturaDoSolo10cm',
						'temperaturaDoSolo20cm',
						'temperaturaDoSolo30cm',
						'temperaturaDoSolo40cm',
						'temperaturaDoSolo50cm',
						'temperaturaDoSolo60cm',
						'ventoDirecao1DesvioPadrao',
						'ventoDirecao2DesvioPadrao',
						'ventoVelocidade1Maxima',
						'ventoVelocidade2Maxima',
						'indice',
						'atributo',
						'nome',
						'unidadeDeMedida',
					]),
				};
			}) as Historico[],
		}));

		this.colunasTabela = this.getColunasTabela();
		this.dadosTabela = this.getDadosTabela(relatoriosFormatados);

		return relatoriosFormatados;
	}

	private obterMunicipioPosto(relatorio: DadosRelatorioVariaveis): string {
		return corrigeDuplicacaoNome(
			`${relatorio.municipio}/${relatorio.nomeposto}`
		);
	}

	private formatarCampos(dado: any, campos: string[]): Partial<Historico> {
		return campos.reduce((acc, campo) => {
			acc[campo as keyof Historico] = isNotNuloOuUndefined(dado[campo])
				? typeof dado[campo] === 'number'
					? numberToBrNumber(dado[campo], 2)
					: dado[campo]
				: '-';
			return acc;
		}, {} as Partial<Historico>);
	}
}
